/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-types */
import * as React from 'react';
import classnames from 'classnames';
import BaseLayout from './base';
// eslint-disable-next-line @typescript-eslint/ban-types
function getLayout(Wrapper, addProps) {
    function Layout(props) {
        const { className, style } = props;
        return (React.createElement(Wrapper, { ...props, style: style, className: classnames(className, 'op-layout') }));
    }
    Layout.role = 'layout';
    Layout.Right = addProps.Right;
    Layout.Left = addProps.Left;
    Layout.Bottom = addProps.Bottom;
    Layout.Top = addProps.Top;
    Layout.Content = addProps.Content;
    return Layout;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function getContent(Wrapper) {
    function Content(props) {
        if (props instanceof Function) {
            props = {
                children: props,
            };
        }
        return React.createElement(Wrapper, { ...props });
    }
    Content.role = 'content';
    return Content;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function getTop(Wrapper) {
    function Top(props) {
        if (props instanceof Function) {
            props = {
                children: props,
            };
        }
        return React.createElement(Wrapper, { ...props });
    }
    Top.role = 'top';
    return Top;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function getBottom(Wrapper) {
    function Bottom(props) {
        if (props instanceof Function) {
            props = {
                children: props,
            };
        }
        return React.createElement(Wrapper, { ...props });
    }
    Bottom.role = 'bottom';
    return Bottom;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function getLeft(Wrapper) {
    function Left(props) {
        if (props instanceof Function) {
            props = {
                children: props,
            };
        }
        return React.createElement(Wrapper, { ...props });
    }
    Left.role = 'left';
    return Left;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function getRight(Wrapper) {
    function Right(props) {
        if (props instanceof Function) {
            props = {
                children: props,
            };
        }
        return React.createElement(Wrapper, { ...props });
    }
    Right.role = 'right';
    return Right;
}
const Layout = getLayout(BaseLayout, {
    Top: getTop(BaseLayout),
    Bottom: getBottom(BaseLayout),
    Left: getLeft(BaseLayout),
    Right: getRight(BaseLayout),
    Content: getContent(BaseLayout),
});
export default Layout;
